var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { class: { light: _vm.light } },
    [
      _c(
        "w-col",
        { class: { light: _vm.light }, attrs: { xs: "12", md: "6" } },
        [
          _c("w-input-autocomplete", {
            attrs: {
              fancy: "",
              up: "",
              "auto-up": false,
              label: _vm.$ct("root-group"),
              items: _vm.filteredTopLevelGroups,
            },
            on: {
              blur: function ($event) {
                return _vm.onParentGroupBlur()
              },
              focus: function ($event) {
                return _vm.onParentGroupFocus()
              },
              "item-click": function ($event) {
                return _vm.emitGroup($event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (g) {
                  return [_vm._v(" " + _vm._s(g.item.Name) + " ")]
                },
              },
            ]),
            model: {
              value: _vm.parentGroup,
              callback: function ($$v) {
                _vm.parentGroup = $$v
              },
              expression: "parentGroup",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-row",
            {
              class: { "sub-group-col": !_vm.light },
              attrs: { "no-margin": "" },
            },
            [
              _c("w-input-autocomplete", {
                class: { mr: !_vm.light },
                style: { flexGrow: 1 },
                attrs: {
                  fancy: "",
                  "auto-up": false,
                  up: "",
                  label: _vm.$ct("sub-group"),
                  items: _vm.filteredSubLevelGroups,
                  disabled: _vm.noParentGroup,
                },
                on: {
                  blur: function ($event) {
                    return _vm.onSubGroupBlur()
                  },
                  focus: function ($event) {
                    return _vm.onSubGroupFocus()
                  },
                  "item-click": function ($event) {
                    return _vm.emitSubGroup($event)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (g) {
                      return [_vm._v(" " + _vm._s(g.item.Name) + " ")]
                    },
                  },
                ]),
                model: {
                  value: _vm.subGroup,
                  callback: function ($$v) {
                    _vm.subGroup = $$v
                  },
                  expression: "subGroup",
                },
              }),
              !_vm.light
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("clear-group"),
                          expression: "$ct('clear-group')",
                        },
                      ],
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.clearGroup()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "trash" } })],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }